<template>
  <div>
    {
    <br />
    <span class="pl-5">type: flex,</span>
    <br />
    <span class="pl-5">altText:</span>
    <span class="form-control" style="display: inline-block;">
      <input
        type="text"
        :placeholder="'This is a Flex Message'"
        v-model="altText"
        maxlength="400"
        @input="onChangeAltText"
      />
    </span>
    ,
    <br />
    <span class="pl-5">contents:</span>
    <br />
    <div class="pl-5">
      <codemirror
        ref="cmCode"
        v-model="code"
        :options="cmOptions"
        @input="onCmCodeChange"
      ></codemirror>
    </div>

    <br />}
    <br />
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror'

// require styles
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-light.css'
// require active-line.js
import 'codemirror/addon/selection/active-line.js'
// closebrackets
import 'codemirror/addon/edit/closebrackets.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/display/autorefresh.js'
export default {
  props: ['value', 'altTextValue'],
  data: function() {
    return {
      code: '',
      altText: '',
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        showCursorWhenSelecting: true,
        matchBrackets: true,
        styleSelectedText: true,
        styleActiveLine: true,
        theme: 'base16-light',
        lineNumbers: true,
        line: true,
        autoFocus: true,
        autoRefresh: true
        // more codemirror options, 更多 codemirror 的高级配置...
      }
    }
  },
  components: {
    codemirror
  },
  mounted: function() {
    if (this.value) {
      this.code = this.value
    }
    if (this.altTextValue) {
      this.altText = this.altTextValue
    }
    var vm = this
    vm.$nextTick(() => {
      vm.$refs.cmCode.codemirror.refresh()
      // cm.refresh()
    })
  },
  methods: {
    onCmCodeChange: function(newCode) {
      this.code = newCode
      this.$emit('input', this.code)
    },
    onChangeAltText: function() {
      this.$emit('update:altTextValue', this.altText)
    }
  },
  watch: {
    value: function(newVal) {
      let value = newVal

      if (typeof value === 'object') {
        value = JSON.stringify(value, null, 4)
      }

      this.code = value
    },
    altTextValue: function(newVal) {
      this.altText = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.CodeMirror pre {
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
}

.CodeMirror pre {
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentLineFlexMessage.vue